<template>
  <div style="font-size: 14px; height: 100%">
    <!-- ========================== 初始状态 ========================== -->
    <div class="add-container" v-if="hasContent">
      <div class="add-content">
        <ul class="welcome-text">
          <li class="steps">添加流程：&nbsp;&nbsp;1.选择数据源&nbsp;&nbsp; 2.编辑推送方案&nbsp;&nbsp; 3.完成</li>
        </ul>

        <div class="add-scheme" @click="hasContentFun">
          <div class="add-content">
            <i class="el-icon-plus"></i>
            <div>添加推送方案</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========================== 有数据状态 ========================== -->
    <div v-else style="height: 100%">
      <div class="content-container" style="height: 100%">
        <!-- header -->
        <div class="content-header">
          <img src="@/assets/img/views/fiveBars/five_bar_logo.png" />
          <div style="display: flex; align-items: center; justify-content: space-between">
            <div style="margin-right: 20px; cursor: pointer" @click="isShow = true"><i class="el-icon-s-tools"></i>&nbsp;&nbsp;设置</div>
            <div>
              <span :class="['iconfont', isMutedAll ? 'icon-jingyin-F' : 'icon-yinliang-F']" style="cursor: pointer" @click="muteAll"></span>
              &nbsp;&nbsp;&nbsp;静音
            </div>
          </div>
        </div>

        <!-- body -->
        <div class="content-body" style="height: calc(100% - 43px)">
          <div class="content-grid">
            <div v-for="(item, i) in filteredList" :key="i" :class="['content-item', filteredList.length <= 3 ? 'content-item-width-3' : 'content-item-width-5', item.isOpen === 1 && item.isRun === 1 && wsStatus === 'success' ? 'content-item-success active1' : '', (item.isOpen === 1 && item.isRun === 1 && wsStatus === 'error') || (item.isOpen === 1 && item.isRun === 0 && wsStatus === 'error') ? 'content-item-danger active2' : '', item.isOpen === 1 && item.isRun === 0 && wsStatus === 'success' ? 'content-item-info' : '']">
              <template v-if="item.isOpen === 1">
                <!-- 状态栏 -->
                <div
                  :class="[
                    'content-item-state',
                    {
                      'state-success': item.isOpen === 1 && item.isRun === 1 && wsStatus === 'success',
                      'state-danger': (item.isOpen === 1 && item.isRun === 1 && wsStatus === 'error') || (item.isOpen === 1 && item.isRun === 0 && wsStatus === 'error'),
                      'state-info': item.isOpen === 1 && item.isRun === 0 && wsStatus === 'success',
                    },
                  ]">
                  <span v-if="item.isOpen === 1 && item.isRun === 1 && wsStatus === 'success'" style="color: #2dc826">运行中</span>
                  <span v-if="(item.isOpen === 1 && item.isRun === 1 && wsStatus === 'error') || (item.isOpen === 1 && item.isRun === 0 && wsStatus === 'error')" style="color: #f44c4c">连接中...</span>
                  <span v-if="item.isOpen === 1 && item.isRun === 0 && wsStatus === 'success'" style="color: #687275">已暂停</span>
                  <i class="el-icon-close" style="color: #333; font-size: 20px; cursor: pointer; float: right; margin-right: 10px" @click="cloesItem(item)"></i>
                </div>

                <!-- 标题 -->
                <div class="content-item-title" :title="item.name">
                  {{ item.name }}
                </div>

                <!-- 内容区 -->
                <div class="content-item-content" style="height: calc(100% - 140px)" :ref="'text_' + item.id">
                  <!-- 加载中 -->
                  <div class="loading-container" v-if="wsStatus === 'error'">
                    <div class="loading-container-inner">
                      <i class="el-icon-loading"></i>
                      <div>待接收新数据</div>
                    </div>
                  </div>

                  <!-- 正常内容 -->
                  <template v-else>
                    <div class="content-item-content-item" v-for="(message, i2) in item.messageList" :key="i2">
                      <div class="content-item-content-item-text">
                        <!-- 视频 / 图片区域 -->
                        <template v-if="message.videoImage && item.isShowMedia === 1">
                          <div class="top-video-image" v-if="filteredList.length > 3">
                            <video style="width: 100%; height: 100%; cursor: pointer" @click="isVideoFn(message.videoUrl)" :src="message.videoUrl" fit="fill" v-if="message.videoUrl && message.videoImage"></video>
                            <el-image style="width: auto; height: 100%" :preview-src-list="[message.videoImage]" :src="message.videoImage" fit="fill" v-else></el-image>
                          </div>
                        </template>
                        <div class="content-text">
                          <div style="margin-bottom: 20px">
                            <div v-html="message.content"></div>
                            <!-- {{ message.content }} -->
                            <!-- 超出换行 -->
                            <!-- <div v-if="message.sourceUrl && item.isShowMedia == 1" style="margin-top: 10px; display: grid; grid-template-columns: 50px 1fr">
                              <span style="display: inline-block">链接：</span>
                              <a :href="message.sourceUrl" target="_blank" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #409eff; font-size: 12px; margin-left: -10px">
                                {{ message.sourceUrl }}
                              </a>
                            </div> -->
                          </div>
                          <div class="content-info" v-if="message.videoImage && item.isShowMedia === 1">
                            <div v-if="filteredList.length <= 3" class="videoAndimg">
                              <video style="width: 100%; height: 100%; cursor: pointer" @click="isVideoFn(message.videoUrl)" :src="message.videoUrl" v-if="message.videoUrl && message.videoImage"></video>
                              <el-image style="width: auto; height: 100%" :preview-src-list="[message.videoImage]" :src="message.videoImage" fit="fill" v-else></el-image>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 分割线 -->
                      <div class="content-divider"></div>

                      <!-- 底部按钮 -->
                      <div class="content-item-content-item-bottom" :style="{ 'justify-content': filteredList.length <= 3 ? 'end' : 'space-between' }">
                        <div :style="{ 'margin-right': filteredList.length <= 3 ? '30px' : '0' }">
                          <el-link :underline="false" type="primary" @click="toLink(message)"> <span class="iconfont icon-lianjie"></span> 原文 </el-link>
                        </div>
                        <!-- <div :style="{ 'margin-right': filteredList.length <= 3 ? '30px' : '0' }" v-if="message.videoUrl || message.videoImage">
                          <el-link :underline="false" type="primary" @click="download(message)"> <i class="el-icon-bottom"></i> 下载 </el-link>
                        </div> -->
                        <div>
                          <el-link :underline="false" type="primary" @click="copyText(message)"> <span class="iconfont icon-fuzhi"></span> 复制 </el-link>
                        </div>
                      </div>
                    </div>
                    <!-- 未读数量 -->
                  </template>
                  <div class="content-item-num" v-if="item.isOpen === 1 && item.isRun === 0 && wsStatus === 'success'" @click="scrollToBottom(item)">
                    <span class="iconfont icon-iconfontxiangxiajiazaigengduo" style="font-size: 10px"></span>
                    {{ item.unreadQuantity || 0 }}条
                  </div>
                  <!-- <div class="loading-container">
                    <div class="loading-container-inner">
                      <div style="border: 1px solid #f44c4c;color: #f44c4c;width: 310px;padding: 10px;background: rgba(255, 238, 240, 0.9);border-radius:4px;">
                        <i class="el-icon-info" style="font-size: 25px;margin-right: 10px;"></i>
                        数据源：“全国监测舆情信息负面”已到期，请关联其他数据源展示
                      </div>
                    </div>
                  </div> -->
                </div>

                <!-- 底部控制按钮 -->
                <div class="content-item-bottom" v-if="wsStatus === 'success'">
                  <span class="iconfont icon-qingchu" style="font-size: 30px" @click="clearItem(item)"></span>
                  <span :class="['iconfont', item.isOpen === 1 && item.isRun === 1 ? 'icon-bofang_zanting' : 'icon-bofangzanting']" style="font-size: 50px" @click="changeRun(item)"></span>
                  <span :class="['iconfont', item.isMuted === 1 ? 'icon-shengyinguanbi' : 'icon-shengyin']" style="font-size: 30px" @click="changeMute(item)"></span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ========================== 右侧设置抽屉 ========================== -->
    <meunList :planList="planList" :isShow="isShow" @closeDrawer="isShow = !isShow" @update:planList="planList = $event" @closeDrawersssss="closeDrawersssss"></meunList>

    <!-- ========================== 展开图标 ========================== -->
    <i class="el-icon-d-arrow-right arrowRight" @click="isShow = !isShow"></i>

    <!-- ========================== 视频弹窗 ========================== -->
    <div class="videoBox" @click.self="isVideo = false" v-if="isVideo">
      <video style="height: 100%" controls :src="videoSrc" @click.stop></video>
    </div>
  </div>
</template>

<script>
import { WebSocketClient } from '@/utils/webSocket/WebSocketClient'
import { domainSend, domainList, domainMsgGetUrl, batchUpdate, domainUpdate, domainMsgCount, domainRun } from '@/api/fiveBar/index'
import meunList from '@/views/fiveBar/meunList'
const url = 'https://www.yuqing.cn'

export default {
  components: { meunList },

  data() {
    return {
      hasContent: true,
      planList: [],
      userInfo: null,
      socketUrl: '',
      ws: null,
      wsStatus: '',
      isMutedAll: false,
      timer: null,
      itemTimers: {},
      isShow: false,
      disconnectTimer: null,
      isVideo: false,
      videoSrc: '',
      audioList: [
        { name: '水滴声.mp3', id: 1, isPlaying: false, src: url + '/music/voice_one.mp3', audioElement: null },
        { name: '门铃声.mp3', id: 2, isPlaying: false, src: url + '/music/voice_two.mp3', audioElement: null },
        { name: '风铃声.mp3', id: 3, isPlaying: false, src: url + '/music/voice_three.mp3', audioElement: null },
        { name: '古筝声.mp3', id: 4, isPlaying: false, src: url + '/music/voice_four.mp3', audioElement: null },
        { name: '波浪声.mp3', id: 5, isPlaying: false, src: url + '/music/voice_five.mp3', audioElement: null },
      ],
      isAutoScrolling: false,
    }
  },

  computed: {
    filteredList() {
      return this.planList.filter((item) => item.isOpen === 1)
    },
  },

  created() {
    this.teleportFn()
    this.getDomainList()
  },

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('user'))
    this.domainMsgGetUrl()
    // document.addEventListener('visibilitychange', this.handleVisibilityChange)

    const unlock = () => {
      const a = new Audio(this.audioList[0]?.src)
      a.volume = 0
      a.play()
        .then(() => {
          a.pause()
          a.currentTime = 0
        })
        .catch(() => {})
      document.removeEventListener('click', unlock)
    }
    document.addEventListener('click', unlock, { once: true })
  },

  beforeDestroy() {
    Object.keys(this.itemTimers).forEach((itemId) => this.clearItemTimer(itemId))
  },

  methods: {
    //传送一个接口过去
    async teleportFn() {
      try {
        const res = await domainSend(this.$store.state.user)
        if (res.data.code !== 200) return this.$message({ message: '传送接口失败', type: 'warning' })
      } catch (e) {
        console.log(e)
      }
    },

    /* ==================== 初始状态 ==================== */
    hasContentFun() {
      this.hasContent = false
      this.isShow = true
    },

    /* ==================== 获取方案 ==================== */
    async getDomainList() {
      try {
        const res = await domainList({ orgId: this.$store.state.user.organizationId, userId: this.$store.state.user.userId })
        if (res.data.code === 200) {
          this.planList = res.data.data.map((item) => ({
            ...item,
            scrollPaused: false,
          }))

          // 为已打开但暂停的项启动定时器
          this.planList.forEach((item) => {
            if (item.isOpen === 1 && item.isRun === 0) {
              this.startItemTimer(item.id)
            }
          })

          this.isMutedAll = this.planList.every((item) => item.isMuted === 1)
          if (this.planList.every((item) => item.isOpen === 0)) {
            this.hasContent = true
          } else {
            this.hasContent = false
          }
        }
      } catch {
        this.$message({ message: '获取方案列表失败', type: 'warning' })
      }
    },

    closeDrawersssss() {
      if (this.planList.every((item) => item.isOpen === 0)) {
        this.hasContent = true
      } else {
        this.hasContent = false
      }
    },

    /* ==================== WebSocket ==================== */
    async domainMsgGetUrl() {
      try {
        const res = await domainMsgGetUrl(this.userInfo.userId)
        if (res.data.code === 200) {
          this.socketUrl = res.data.msg
          this.initSocket()
        }
      } catch (e) {
        console.log(e)
      }
    },

    initSocket() {
      const url = this.socketUrl + '/websocket?userId=WDG:user:' + this.userInfo.userId + '_' + this.userInfo.organizationId
      this.ws = new WebSocketClient(url)
      this.ws.connect()
      this.ws.onclose(() => (this.wsStatus = 'error'))
      this.ws.onerror(() => (this.wsStatus = 'error'))
      this.ws.onopen(() => (this.wsStatus = 'success'))

      this.ws.onmessage((event) => {
        setTimeout(() => {
          try {
            const message = JSON.parse(event.data)
            const idx = this.planList.findIndex((p) => p.id == message.id)
            if (idx === -1) return
            const item = this.planList[idx]
            if (!item.messageList) {
              this.$set(item, 'messageList', [])
            }
            message.content = this.stripLinkLine(message.content)
            const contentStr = message
            item.messageList.push(contentStr)

            this.$nextTick(() => {
              if (!item.scrollPaused) {
                const dom = this.$refs[`text_${item.id}`]
                if (dom && dom[0]) {
                  dom[0].scrollTop = dom[0].scrollHeight
                }
              }
            })

            //  限制最多保留100条
            if (item.messageList.length > 100) {
              item.messageList.splice(0, item.messageList.length - 100)
            }

            if (item.isMuted === 0 && item.musicType) {
              const audio = this.audioList?.find((a) => a.id === item.musicType)
              if (audio?.src) {
                // 复用缓存的 audioElement，避免频繁创建
                if (!audio.audioElement) {
                  audio.audioElement = new Audio(audio.src)
                  audio.audioElement.load()
                }
                audio.audioElement.currentTime = 0
                audio.audioElement.play().catch((e) => {
                  if (e.name === 'NotAllowedError' && !this.hasShownAudioPrompt) {
                    this.$message({ message: '请点击页面任意位置启用声音提示', type: 'warning' })
                    this.hasShownAudioPrompt = true
                    const handler = () => {
                      audio.audioElement.play().catch(() => {})
                      document.removeEventListener('click', handler)
                    }
                    document.addEventListener('click', handler, { once: true })
                  }
                })
              }
            }
          } catch (e) {
            console.error('Failed to process WebSocket message:', e)
          }
        }, 500)
      })
    },

    stripLinkLine(content = '') {
      return content
        .replace(
          /^链接\s*：\s*(.+)$/gm, // 匹配“链接：”后面有内容
          (match, url) => `链接： <a href="${url.trim()}" target="_blank" rel="noopener" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #409eff;width:80%;display:inline-block;line-height: 12px;">${url.trim()}</a>`
        )
        .replace(/^链接\s*：\s*$/gm, '') // 匹配“链接：”后面没内容
        .trim()
    },

    //放大视频
    isVideoFn(item) {
      this.isVideo = true
      this.videoSrc = item
    },

    /* ==================== 静音 ==================== */
    muteAll() {
      if (this.isMutedAll) return
      const arr = this.planList.filter((item) => item.id).map((item) => ({ id: item.id, isMuted: 1 }))
      this.batchUpdateFun(arr)
    },

    async batchUpdateFun(arr) {
      try {
        const res = await batchUpdate(arr)
        if (res.data.code === 200) {
          this.$message({ message: '设置成功', type: 'success' })
          arr.forEach(({ id }) => {
            const target = this.planList.find((p) => p.id === id)
            if (target) target.isMuted = 1
          })
          this.isMutedAll = true
        }
      } catch (e) {
        console.log(e)
      }
    },

    /* ==================== 开关/暂停/清除 ==================== */
    cloesItem(item) {
      item.isOpen = 0
      item.isRun = 0
      this.domainUpdateFun({
        id: item.id,
        isOpen: item.isOpen,
        isRun: item.isRun,
        userId: this.userInfo.userId,
        orgId: this.userInfo.organizationId,
      })
      this.clearItemTimer(item.id)
      this.closeDrawersssss()
    },

    clearItem(item) {
      item.messageList = []
    },

    changeRun(item) {
      this.$set(item, 'scrollPaused', false)
      item.isRun = item.isRun === 1 ? 0 : 1
      if (item.isRun === 1) {
        this.$set(item, 'scrollPaused', false)
        item.unreadQuantity = 0
        this.clearItemTimer(item.id)
      } else {
        this.startItemTimer(item.id)
      }
      this.domainRunFun({
        id: item.id,
        isRun: item.isRun,
        userId: this.userInfo.userId,
        orgId: this.userInfo.organizationId,
      })
    },

    async domainRunFun(payload) {
      try {
        const res = await domainRun(payload)
        if (res.data.code === 200) {
          // this.$message({ message: '设置成功', type: 'success' })
        }
      } catch {
        this.$message({ message: '获取方案列表失败', type: 'warning' })
      }
    },

    //跳转原文-新页面打开
    toLink(item) {
      if (item && item.sourceUrl) {
        const link = item.sourceUrl
        window.open(link, '_blank')
        return link
      }
      return null
    },

    //下载
    async download(item) {
      const url = item.videoUrl || item.videoImage
      if (!url) return
      try {
        const res = await fetch(url)
        const blob = await res.blob()
        const fileName = url.split('?')[0].split('/').pop() || 'download'
        const blobUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = fileName
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        // 释放内存
        URL.revokeObjectURL(blobUrl)
      } catch (e) {
        this.$message.error('下载失败，请稍后重试')
      }
    },

    copyText(item) {
      let text = item.content

      // 统一去掉所有 HTML 标签
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = text
      text = tempDiv.innerText || tempDiv.textContent

      // 复制纯文本
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)

      this.$message.success('复制成功')
    },

    /* ==================== 未读定时器 ==================== */
    startItemTimer(itemId) {
      this.clearItemTimer(itemId)
      this.itemTimers[itemId] = setInterval(() => {
        const target = this.planList.find((p) => p.id === itemId)
        if (target) this.domainMsgCountFun(target)
      }, 5000)
    },

    async domainMsgCountFun(item) {
      try {
        const res = await domainMsgCount({
          id: item.id,
          userId: this.userInfo.userId,
          orgId: this.userInfo.organizationId,
        })
        if (res.data.code === 200) {
          const idx = this.planList.findIndex((p) => p.id === item.id)
          if (idx !== -1) {
            this.$set(this.planList, idx, {
              ...this.planList[idx],
              unreadQuantity: res.data.data >= 99 ? '99+' : res.data.data,
            })
          }
        }
      } catch (e) {
        console.error('获取未读数量失败:', e)
      }
    },

    clearItemTimer(itemId) {
      if (this.itemTimers[itemId]) {
        clearInterval(this.itemTimers[itemId])
        delete this.itemTimers[itemId]
      }
    },

    /* ==================== 单个静音 ==================== */
    changeMute(item) {
      item.isMuted = item.isMuted === 1 ? 0 : 1
      this.domainUpdateFun({
        id: item.id,
        isMuted: item.isMuted,
        userId: this.userInfo.userId,
        orgId: this.userInfo.organizationId,
      })
    },

    async domainUpdateFun(payload) {
      try {
        const res = await domainUpdate(payload)
        if (res.data.code === 200) {
          this.$message({ message: '设置成功', type: 'success' })
          this.planList.forEach((p) => {
            if (p.id === payload.id) {
              Object.assign(p, payload)
            }
          })
          this.isMutedAll = this.planList.every((p) => p.isMuted === 1)
        }
      } catch (e) {
        console.log(e)
      }
    },

    /* ================= 新增：滚动事件 ================= */
    handleScroll(item, e) {
      if (this.isAutoScrolling) return
      const el = e.target
      const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200

      if (isBottom && item.scrollPaused) {
        // 用户滚动到底，恢复自动滚动
        // this.$set(item, 'scrollPaused', false)
        // if (item.isRun === 0) {
        //   this.changeRun(item)
        // }
      } else if (!isBottom && !item.scrollPaused && item.isRun === 1) {
        // 用户手动往上滚，暂停推送
        this.$set(item, 'scrollPaused', true)
        this.changeRun(item) // 暂停推送
      }
    },

    /* ============== 新增：点击未读数量，滚动到底并恢复推送 ============== */
    scrollToBottom(item) {
      const dom = this.$refs[`text_${item.id}`]
      if (dom && dom[0]) {
        this.isAutoScrolling = true
        dom[0].scrollTo({ top: dom[0].scrollHeight, behavior: 'smooth' })
        setTimeout(() => {
          this.isAutoScrolling = false
        }, 400) // 时长按UI适配
      }
      if (item.isRun === 0) {
        this.changeRun(item) // 只会执行一次
      }
    },

    /* ==================== 离开/进入页面 ==================== */
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.disconnectTimer = setTimeout(() => {
          if (this.ws) {
            this.planList.forEach((item) => {
              if (item.isRun === 1 && item.isOpen === 1) {
                this.changeRun(item)
              }
            })
            this.ws.close()
          }
        }, 600000)
      } else {
        if (this.disconnectTimer) {
          clearTimeout(this.disconnectTimer)
          this.disconnectTimer = null
        }
        if (!this.ws.socket) {
          this.initSocket()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// ========================== 初始状态 ==========================
.add-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('~@/assets/img/views/fiveBars/five_bar_bg.png') no-repeat;
  background-size: cover;

  .add-content {
    width: 1200px;

    .welcome-text {
      color: #fff;
      text-align: center;
      margin-bottom: 40px;

      .title {
        font-size: 40px;
        margin: 25px 0;
        color: #333;
      }

      .steps {
        color: #888c95;
        font-size: 14px;
      }
    }

    .add-scheme {
      width: 100%;
      height: 508px;
      background: rgba(253, 253, 253, 0.6);
      border: 2px dotted rgba(86, 121, 240, 0.31);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 6px;

      .add-content {
        text-align: center;
        color: #2e59ec;

        .el-icon-plus {
          font-size: 36px;
          margin-bottom: 10px;
        }

        div {
          font-size: 18px;
        }
      }
    }
  }
}

// ========================== 有内容状态 ==========================
.content-container {
  .content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 10px;
  }

  .content-body {
    padding: 10px;
    background: url('~@/assets/img/views/fiveBars/five_bar_bg.png') no-repeat;
    background-size: cover;

    .content-grid {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      .content-item {
        margin: 0 10px 0 0;
        height: 100%;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        padding: 20px 10px 20px 20px;
        border: 1px solid #e5e5e5;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
          height: 5px;
          background: linear-gradient(270.41deg, rgba(219, 219, 219, 0) 0%, #dcdcdd 99.99%);
        }

        &.active1 {
          background: linear-gradient(187.78deg, #defff5 0.94%, #f4f8ff 97.9%);
          border: 1px solid #2dc926;

          &::before {
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(45, 201, 38, 0.2) 20%, #2dc926 50%, rgba(45, 201, 38, 0.2) 80%, rgba(255, 255, 255, 0) 100%);
            background-size: 200% 100%;
            animation: loading 1.5s linear infinite;
          }
        }

        &.active2 {
          background: linear-gradient(187.7deg, #ffece8 0.92%, #f4f8ff 97.95%);
          border: 1px solid #f9c3b0;

          &::before {
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 114, 114, 0.2) 20%, #ff7272 50%, rgba(255, 114, 114, 0.2) 80%, rgba(255, 255, 255, 0) 100%);
            background-size: 200% 100%;
            animation: loading 1.5s linear infinite;
          }
        }

        .content-item-bottom {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: #fff;
          padding: 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

          & > * {
            cursor: pointer;
          }
        }

        .content-item-state {
          &::before {
            content: '';
            display: inline-block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            margin-right: 10px;
            background-color: #687275;
          }

          &.state-success {
            color: #2dc926;
            &::before {
              background-color: #2dc926;
            }
          }

          &.state-danger {
            color: #f44c4c;
            &::before {
              background-color: #f44c4c;
            }
          }

          &.state-info {
            color: #687275;
            &::before {
              background-color: #687275;
            }
          }
        }

        .content-item-title {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          margin: 15px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }

        .content-item-content {
          overflow: hidden;
          padding-right: 22px;
          &:hover {
            overflow-y: scroll;
            padding-right: 14px;
          }
          .loading-container {
            // position: absolute;
            // top: 0;
            // left: 0;
            // right: 0;
            // bottom: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .loading-container-inner {
              text-align: center;
              color: #f44c4c;

              i {
                font-size: 40px;
                margin-bottom: 10px;
              }
            }
          }

          .content-item-content-item {
            background: #fff;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 20px;

            .top-video-image {
              height: 220px;
              background: #000;
              text-align: center;
            }

            .content-text {
              white-space: pre-wrap;
              padding: 20px;
              line-height: 25px;
              color: #333;
              font-size: 14px;

              .content-title {
                margin-bottom: 5px;
              }

              .content-summary {
                margin-bottom: 5px;
              }

              .content-info {
                display: flex;

                .videoAndimg {
                  // width: 30%;
                  height: 200px;
                  border-radius: 4px;
                  overflow: hidden;
                  margin-right: 20px;
                }

                .info-details {
                  width: 70%;

                  .info-row {
                    display: flex;
                    align-items: center;
                    max-width: 100%;

                    .info-link {
                      color: #409fff;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 75%;
                    }
                  }
                }
              }
            }

            .content-divider {
              height: 1px;
              background: #f5f5f5;
            }

            .content-item-content-item-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 15px 40px;

              .iconfont {
                font-size: 15px;
              }
            }
          }
        }

        .content-item-num {
          position: absolute;
          bottom: 100px;
          right: 50%;
          transform: translateX(50%);
          width: 72px;
          height: 35px;
          background: #fcfcfc;
          border: 1px solid rgba(170, 212, 166, 0.45);
          border-radius: 14px;
          text-align: center;
          line-height: 35px;
          font-size: 12px;
          color: #4cb556;
          cursor: pointer;
        }
      }

      // 数量小于等于三
      .content-item-width-3 {
        width: 580px;
      }

      // 数量大于三
      .content-item-width-5 {
        flex: 1;
      }

      // 打开运行无错误
      .content-item-success {
        border-color: rgba(45, 201, 38, 0.39);
        background: linear-gradient(187.78deg, #defff5 0.94%, #f4f8ff 97.9%);
      }

      // 打开运行并错误
      .content-item-danger {
        border-color: rgba(249, 195, 176, 1);
        background: linear-gradient(187.7deg, #ffece8 0.92%, #f4f8ff 97.95%);
      }

      // 打开暂停无错误
      .content-item-info {
        border-color: rgba(222, 222, 222, 1);
        background: linear-gradient(187.7deg, #eeeeee 0.92%, #f4f8ff 97.95%);
      }
    }
  }
}

// ========================== 其它 ==========================
.arrowRight {
  font-size: 30px;
  position: fixed;
  top: 50%;
  left: 10px;
  cursor: pointer;
  transform: translateY(-50%);
}

.videoBox {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

@keyframes loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: none;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(245, 247, 250, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  // background-color: rgba(0, 0, 0, 0.2);
}
</style>
